import React from 'react';
import { NumericFormat, NumericFormatProps, NumberFormatValues } from 'react-number-format';

interface NumberFormatNorwegianCurrencyProps extends NumericFormatProps {
    onValueChange: (values: NumberFormatValues) => void;
    value?: string | number;
    placeholder?: string;
    suffix?: string;
    decimalScale?: number;
    allowNegative?: boolean;
}

interface FormatOptions {
    decimalScale?: number;
    decimalSeparator?: string;
    thousandSeparator?: string;
}

const isInt = (value: number) => value % 1 === 0;

export const formatCurrencyValue = (value: number, options?: FormatOptions): string => {
    const { decimalScale = 2, decimalSeparator = ',', thousandSeparator = ' ' } = options ?? {};
    return (isInt(value) ? value.toString() : value.toFixed(decimalScale))
        .toString()
        .replace('.', decimalSeparator)
        .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
};

const NumberFormatNorwegianCurrency = ({
    value,
    onValueChange,
    placeholder = '0 kr',
    suffix = ' kr',
    allowNegative = false,
    decimalScale = 2,
    thousandSeparator = ' ',
    decimalSeparator = ',',
    ...rest
}: NumberFormatNorwegianCurrencyProps): JSX.Element => (
    <NumericFormat
        thousandSeparator={thousandSeparator}
        suffix={suffix}
        allowNegative={allowNegative}
        value={value}
        placeholder={placeholder}
        decimalScale={decimalScale}
        onValueChange={onValueChange}
        decimalSeparator={decimalSeparator}
        inputMode="decimal"
        {...rest}
    />
);

export default NumberFormatNorwegianCurrency;
